module.exports = __webpack_public_path__ + "static/media/nav_04.294fa188.svg";